module.exports = __webpack_public_path__ + "img/ic_not_open.092f6c82.png";